// Public re-export of the otherwise-private `ui._components.character` leaf, so sibling tiles
// (e.g. the minimal card tile) can render a glyph exactly like a glyph tile does without
// reaching across the `_components.*` encapsulation boundary themselves.
export { MorphemeGlyphTileCharacter } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.tile.ui._components.character";
